import React from "react";

interface CardProps {
  title?: string;
  icon?: string;
  children: React.ReactNode;
}

const Card: React.FC<CardProps> = ({ title, icon, children }) => (
  <div className="card">
    {title && (
      <h3 className="card-title">
        {icon && <span style={{ marginRight: '0.5rem' }}>{icon}</span>}
        {title}
      </h3>
    )}
    {children}
  </div>
);

export default Card;